import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/Login';

import EdsReuest from '@/components/EDSClient/EDSRequest'

import ManageCriteria from '@/components/DPEBB/Administrator/ManageCriteria'

 


import ManageEdsAllocation from '@/components/DPEBB/Administrator/ManageEDSCriteria'

import ViewEdsAllocation from '@/components/DPEBB/Administrator/ViewEDSAndCriteria'

// file download
import DPFileDownLoad from '@/components/DPEBB/Administrator/FileDownLoad'

//import DPFileDownLoad from '@/components/DPEBB/Administrator/FileDownLoad'

//faq
import DpebbFaq from '@/Common/Default/Faq';
//contact us
import DpebbContactus from '@/Common/Default/ContactUs';
//Dental
 
import EDSHome from '../components/EDSClient/EDSHome';
//DPEBB

import DPEBBHome from '../components/DPEBB/Home';
import DPEBBMainHome from '../components/DPEBB/MainHome';
import UpdatePasswordHome from '@/components/DPEBB/Administrator/UserUpdatePassowrd' ;

//SuperUser

import SuperUserManageProviders from '../DPEBB/SuperUser/ManageProviders';
import SuperUserManageClinics from '../DPEBB/SuperUser/ManageClinics';

 
import SuperUserManageBulletins from '../DPEBB/SuperUser/ManageBulletins';
import SuperUserManagerUser from '../DPEBB/SuperUser/ManageUser';
import SuperUserManagerRolePer from '../DPEBB/SuperUser/ManageRolePermissions';
import SuperUserManagePassword from '../DPEBB/SuperUser/ManageUserPassword';
 
import SuperUserManageUserRoles from '../DPEBB/SuperUser/ManageUserRoles';
//SystemAdmin
 
import AdminUserManageProviders from '../DPEBB/Administrator/ManageProviders';
import AdminUserManageClinics from '../DPEBB/Administrator/ManageClinics';

import AdminUserManageBulletins from '../DPEBB/Administrator/ManageBulletins';
import AdminManagerUser from '../DPEBB/Administrator/ManageUser';
import AdminManagerRolePer from '../DPEBB/Administrator/ManageRolePermissions';
import AdminUserManageUserRoles from '../DPEBB/Administrator/ManageUserRoles';
  
//HelpDesk
import HelpDeskManagePassword from '../DPEBB/HelpDesk/ManageUserPassword';

import { store } from '../Store/store';
Vue.use(Router);
export const router =  new Router( {mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: Login
    // },
    {
      name: 'home',
      path: '/login',
      public: true,
      components: { default: Login}
    },
    ///DPEBB/Assessor/ViewEdsAllocation
    {
      name: 'ViewEdsCriteria',
      path: '/DPEBB/Assessor/ViewEdsAllocation',
      components: { default: ViewEdsAllocation}
    },
    //EDS //Dental/SuperUser/EdsRequest
    {
      name: 'EdsSupReuest',
      path: '/EDSApplication/SuperUser/EdsRequest',
      components: { default: EdsReuest}
    },
    //EDS //Dental/SuperUser/EdsRequest
    {
      name: 'EdsComReuest',
      path: '/EDSApplication/Provider/EdsRequest',
      components: { default: EdsReuest}
    },
    
      //EDS //Dental/SuperUser/EdsRequest
    {
      name:'ManageCriteria',
      path: '/DPEBB/SuperUser/ManageCriteria',
      components: { default: ManageCriteria}
    },
     ///DPEBB/SuperUser/UserEdsAllocation
    {
      name:'ManageEDSStandard',
      path: '/DPEBB/SuperUser/ManageEdsAllocation',
      components: { default: ManageEdsAllocation}
    },
    
    {
      name:'ManageAdminEDSStandard',
      path: '/DPEBB/Administrator/ManageEdsAllocation',
      components: { default: ManageEdsAllocation}
    },
    // file downlaod DPFileDownLoad 
    {
      name: 'DPFileDownLoad',
      path: '/DPEBB/FileManager/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // {
    //   name: 'DPEBBGreenScreenHome',
    //   path: '/DPEBB/DPEBBGreenScreenHome',
    //   components: { default: DPEBBGreenScreenHome}
    // },

    // file downlaod DPFileDownLoad
    {
      name: 'DPFileAdminDownLoad',
      path: '/DPEBB/FileAdministrator/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // file downlaod DPFileDownLoad
    {
    name: 'DPFilesuperDownLoad',
    path: '/DPEBB/SuperUser/FilesDownload',
    components: { default: DPFileDownLoad}
  },

    ////DPEBB/Finance/FilesDownload
    // file downlaod DPFileDownLoad
    { 
      name: 'DPFileFinanaceDownLoad',
      path: '/DPEBB/Finance/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    // file downlaod DPFileDownLoad
    { 
      name: 'DPFileLeadDownLoad',
      path: '/DPEBB/LeadAssessor/FilesDownload',
      components: { default: DPFileDownLoad}
    },
    //  DpebbFaq DpebbContactus
    {
      name: 'DpebbFaq',
      path: '/DPEBB/Faq',
      components: { default: DpebbFaq}
    },
    {
      name: 'DpebbContactus',
      path: '/DPEBB/Contactus',
      components: { default: DpebbContactus}
    },

    //Dental EDSClient/Home
    {
      name: 'EDSHome1',
      path: '/EDSClient/Home',
      components: { default: EDSHome},
    },

    {
      name: 'EDSAdminHome',
      path: '/EDS/Home',
      components: { default: EDSHome},
    },
    //EDSClient
    {
      name: 'EDSHome',
      path: '/EDSClient/Home',
      components: { default: EDSHome},
    },
   
     //DPEBB
     {
      name: 'DPEBBHome',
      path: '/DPEBB/Home',
      components: { default: DPEBBHome}
    },
    {
      name: 'DPEBBMainHome',
      path: '/DPEBB/MainHome',
      components: { default: DPEBBMainHome},
    //   beforeEnter(to,from,next){
    //     //alert('at route')
    //     //next();
    //       if(store.state.AccessToken || localStorage.getItem("access_token") !== null){
    //       if( localStorage.getItem("access_token") !== null){
    //         next();
    //       }
    //       else{
    //         next('/');
    //       }
    //   }
    // }
    }, 
    {
      name: 'UpdatePassword',
      path: '/UpdatePassword',
      components: { default: UpdatePasswordHome},
    },
   
    {
      name:'SuperUserManageProviders',
      path:'/DPEBB/SuperUser/ManageProviders',
      components:{default:SuperUserManageProviders}
    },
    {
      name:'SuperUserManageClinics',
      path: '/DPEBB/SuperUser/ManageClinics',
      components:{default: SuperUserManageClinics}
    },
    

    {
      name:'SuperUserManageBulletins',
      path:'/DPEBB/SuperUser/ManageBulletins',
      components:{default:SuperUserManageBulletins}
    },
    {
      name: 'SuperUserManagerUser',
      path: '/DPEBB/SuperUser/ManageUsers',
      components: { default: SuperUserManagerUser}
    },
    {
      name: 'SuperUserManagerRolePer',
      path: '/DPEBB/SuperUser/ManageRolePermissions',
      components: { default: SuperUserManagerRolePer}
    },
    {
      name: 'SuperUserManageUserPassword',
      path: '/DPEBB/SuperUser/ManageUserPassword',
      components: { default: SuperUserManagePassword}
    },
    {
      name: 'SuperUserManageUserRoles',
      path: '/DPEBB/SuperUser/ManageUserRoles',
      components: {default:SuperUserManageUserRoles}
    },
  
    {
      name:'AdminUserManageProviders',
      path:'/DPEBB/Administrator/ManageProviders',
      components:{default:AdminUserManageProviders}
    },
    {
      name:'AdminUserManageClinics',
      path: '/DPEBB/Administrator/ManageClinics',
      components:{default: AdminUserManageClinics}
    },
 
    {
      name:'AdminUserManageBulletins',
      path:'/DPEBB/Administrator/ManageBulletins',
      components:{default:AdminUserManageBulletins}
    },
    {
      name: 'AdminManagerUser',
      path: '/DPEBB/Administrator/ManageUsers',
      components: { default: AdminManagerUser}
    },
    {
      name: 'AdminManagerRolePer',
      path: '/DPEBB/Administrator/ManageRolePermissions',
      components: { default: AdminManagerRolePer}
    },
    {
      name: 'AdminUserManageUserRoles',
      path: '/DPEBB/Administrator/ManageUserRoles',
      components: {default:AdminUserManageUserRoles}
    },
  

   
    //HelpDesk
    {
      name: 'HelpDeskManagePassword',
      path: '/DPEBB/HelpDesk/ManageUserPassword',
      components: { default: HelpDeskManagePassword},
    },
    {
      path: '*',
      name: 'all',
      component: Login
    }
  ]

});

// router.beforeEach(async (to,from,next) => {
//   //console.log('to.path = ' + to.path)
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login'];
//   const authRequired = !publicPages.includes(to.path);
//   const auth = store.getters.IsAuth;
// //console.log('auth req= = ' + authRequired)
// //console.log('isauth = = ' + auth)
// ////console.log(to.fullPath)
//    if (authRequired && !auth) {
//     //console.log('auth required cant move')
//   //     //auth.returnUrl = to.fullPath;
//       // return 'home';
//        //next("http://localhost:8080/");
//        next({ name: "home" });
//        //store.dispatch('Logout');
//        //router.push({ name: 'home' });
//    }
//    else 
//    {
//     //return true;
//     next();
//    }
// });
